import { Injectable } from '@angular/core';
import { IrisSelectionService } from '@iris/common/services/utils/iris-selection.service';
import { IrisDMSFolderOrFile } from '@iris/modules/dms/utils/file.utils';
@Injectable()
export class IrisDmsSelectionService extends IrisSelectionService<IrisDMSFolderOrFile> {}
